import { AlertOctagon, Bell01, Lightbulb04 } from "@untitledui/icons";
import type { FC } from "react";
import type { PriorityCardGroupKey } from "../types/insight-summary.types";

/** Query string ao navegar para o Copiloto a partir dos cards (alinhar a `COPILOT_TAB_QUERY_PARAM` da feature). */
export const PRIORITY_CARD_COPILOT_TAB_QUERY_PARAM = "tab";

export const PRIORITY_SUMMARY_CARD_DEFINITIONS: Array<{
	key: PriorityCardGroupKey;
	title: string;
	subtitle: string;
	icon: FC<{ className?: string }>;
	iconClassName: string;
	iconBackgroundClassName: string;
}> = [
	{
		key: "reminders",
		title: "Lembretes",
		subtitle: "Prazos a vencer nesta semana",
		icon: Bell01,
		iconClassName: "text-utility-warning-500",
		iconBackgroundClassName: "bg-warning-primary rounded-full",
	},
	{
		key: "alerts",
		title: "Alertas",
		subtitle: "Sinais críticos da semana",
		icon: AlertOctagon,
		iconClassName: "text-fg-error-primary",
		iconBackgroundClassName: "bg-bg-error-primary rounded-full",
	},
	{
		key: "opportunities",
		title: "Oportunidades",
		subtitle: "Melhorias identificadas na semana",
		icon: Lightbulb04,
		iconClassName: "text-utility-gray-500",
		iconBackgroundClassName: "bg-bg-primary rounded-full",
	},
];
